// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AccountMenuButton-cls1___5d5d532ec803018cc77{/*!*/}.AccountMenuButton-cls2__edc0296fb1848c3a7115{overflow:hidden;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "AccountMenuButton-cls1___5d5d532ec803018cc77",
	"cls2": "AccountMenuButton-cls2__edc0296fb1848c3a7115 AccountMenuButton-cls1___5d5d532ec803018cc77"
};
export default ___CSS_LOADER_EXPORT___;
